"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgDatabaseOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.database_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "database_outline_svg__transparent_box" },
            React.createElement("path", { className: "database_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "database_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("path", { d: "M16 2C10.3 2 6 4.15 6 7v18c0 2.85 4.3 5 10 5s10-2.15 10-5V7c0-2.85-4.3-5-10-5zm0 2c4.88 0 8 1.78 8 3s-3.12 3-8 3-8-1.78-8-3 3.12-3 8-3zm0 24c-4.88 0-8-1.78-8-3v-2.94A14.93 14.93 0 0016 24a14.93 14.93 0 008-1.94V25c0 1.22-3.12 3-8 3zm0-6c-4.88 0-8-1.78-8-3v-2.94A14.93 14.93 0 0016 18a14.93 14.93 0 008-1.94V19c0 1.22-3.12 3-8 3zm0-6c-4.88 0-8-1.78-8-3v-2.94A14.93 14.93 0 0016 12a14.93 14.93 0 008-1.94V13c0 1.22-3.12 3-8 3z", id: "database_outline_svg__OUTLINE" })));
}
exports.default = SvgDatabaseOutline;
//# sourceMappingURL=DatabaseOutline.js.map